// Mock data for HangZen Surf + Sea website

export const IMAGES = {
  heroVideo: "https://images.unsplash.com/photo-1664088673619-38b275539bf9?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA2MjJ8MHwxfHNlYXJjaHwyfHxzdXJmaW5nJTIwd2F2ZXN8ZW58MHx8fHwxNzc4NTk4MDU0fDA&ixlib=rb-4.1.0&q=85",
  // Original HangZen photos (from the live site)
  hzPriv1: "https://img1.wsimg.com/isteam/ip/9c27c199-8240-446f-af0d-1ed5fc5c4563/TU9HJptNE7UvH7KZIcisDuAL0w.webp",
  hzPriv2: "https://img1.wsimg.com/isteam/ip/9c27c199-8240-446f-af0d-1ed5fc5c4563/oDPgBYz4cqK5VJ8xOpUXsI7jDM8.webp",
  hzHotel2: "https://img1.wsimg.com/isteam/ip/9c27c199-8240-446f-af0d-1ed5fc5c4563/bJ793vTLafHTvXGkzk9VnLFlYo.webp",
  hzSemi1: "https://img1.wsimg.com/isteam/ip/9c27c199-8240-446f-af0d-1ed5fc5c4563/PHOTO-2026-02-25-13-14-34.jpg",
  hzSemi2: "https://img1.wsimg.com/isteam/ip/9c27c199-8240-446f-af0d-1ed5fc5c4563/PHOTO-2026-02-25-13-30-05.jpg",
  hzGroup1: "https://img1.wsimg.com/isteam/ip/9c27c199-8240-446f-af0d-1ed5fc5c4563/PHOTO-2026-02-25-13-35-33.jpg",
  hzGroup2: "https://img1.wsimg.com/isteam/ip/9c27c199-8240-446f-af0d-1ed5fc5c4563/PHOTO-2026-02-25-13-35-48.jpg",
  hzKids1: "https://img1.wsimg.com/isteam/ip/9c27c199-8240-446f-af0d-1ed5fc5c4563/PHOTO-2026-02-25-13-52-08.jpg",
  hzKids2: "https://img1.wsimg.com/isteam/ip/9c27c199-8240-446f-af0d-1ed5fc5c4563/PHOTO-2026-02-25-13-52-08%202.jpg",
  hzKidsFish1: "https://img1.wsimg.com/isteam/ip/9c27c199-8240-446f-af0d-1ed5fc5c4563/PHOTO-2026-02-24-16-53-38%2016.jpg",
  hzKidsFish2: "https://img1.wsimg.com/isteam/ip/9c27c199-8240-446f-af0d-1ed5fc5c4563/PHOTO-2026-02-24-16-53-38%2019.jpg",
  hzBay1: "https://img1.wsimg.com/isteam/ip/9c27c199-8240-446f-af0d-1ed5fc5c4563/PHOTO-2026-02-24-16-53-39%205.jpg",
  hzBay2: "https://img1.wsimg.com/isteam/ip/9c27c199-8240-446f-af0d-1ed5fc5c4563/PHOTO-2026-02-24-16-53-39%208.jpg",
  hzOffshore1: "https://img1.wsimg.com/isteam/ip/9c27c199-8240-446f-af0d-1ed5fc5c4563/PHOTO-2026-02-25-19-24-41.jpg",
  hzOffshore2: "https://img1.wsimg.com/isteam/ip/9c27c199-8240-446f-af0d-1ed5fc5c4563/PHOTO-2026-02-24-16-53-39%207.jpg",
  hzCoronado1: "https://img1.wsimg.com/isteam/ip/9c27c199-8240-446f-af0d-1ed5fc5c4563/PHOTO-2026-02-24-16-53-38.jpg",
  hzCoronado2: "https://img1.wsimg.com/isteam/ip/9c27c199-8240-446f-af0d-1ed5fc5c4563/PHOTO-2026-02-24-16-53-38%2014.jpg",
  hzWhale1: "https://img1.wsimg.com/isteam/ip/9c27c199-8240-446f-af0d-1ed5fc5c4563/PHOTO-2026-02-25-14-39-40.jpg",
  hzSunset1: "https://img1.wsimg.com/isteam/ip/9c27c199-8240-446f-af0d-1ed5fc5c4563/PHOTO-2026-02-25-15-07-00.jpg",
  hzPaddle1: "https://img1.wsimg.com/isteam/ip/9c27c199-8240-446f-af0d-1ed5fc5c4563/PHOTO-2026-02-27-18-45-59.jpg",
  hzCatalina1: "https://img1.wsimg.com/isteam/ip/9c27c199-8240-446f-af0d-1ed5fc5c4563/PHOTO-2026-02-25-15-32-44.jpg",
  hzNicaragua1: "https://img1.wsimg.com/isteam/ip/9c27c199-8240-446f-af0d-1ed5fc5c4563/PHOTO-2026-02-26-09-12-23.jpg",
  hzHome1: "https://img1.wsimg.com/isteam/ip/9c27c199-8240-446f-af0d-1ed5fc5c4563/IMG_3428.jpeg",
  hzHome2: "https://img1.wsimg.com/isteam/ip/9c27c199-8240-446f-af0d-1ed5fc5c4563/IMG_6037.jpeg",
  hzHome3: "https://img1.wsimg.com/isteam/ip/9c27c199-8240-446f-af0d-1ed5fc5c4563/IMG_2960.jpeg",
  hzJet1: "/jet-ski-assist.jpg",
  hzJet2: "https://img1.wsimg.com/isteam/ip/9c27c199-8240-446f-af0d-1ed5fc5c4563/PHOTO-2025-11-26-08-38-19.jpg",
  hzJet3: "/jet-ski-adventures.jpg",
  hzJet4: "https://img1.wsimg.com/isteam/ip/9c27c199-8240-446f-af0d-1ed5fc5c4563/PHOTO-2025-11-26-08-21-13.jpg",
  hzJet5: "https://img1.wsimg.com/isteam/ip/9c27c199-8240-446f-af0d-1ed5fc5c4563/PHOTO-2025-11-26-08-21-14.jpg",
  // Additional gallery photos from the original site (unique extras)
  hzExtra1: "https://img1.wsimg.com/isteam/ip/9c27c199-8240-446f-af0d-1ed5fc5c4563/jVQu6Smc2pAGxSziWIqrJ2hTJg.webp",
  hzExtra2: "https://img1.wsimg.com/isteam/ip/9c27c199-8240-446f-af0d-1ed5fc5c4563/2kcSLRFYfp69LS8wCEFm7MBYpbA.webp",
  hzExtra3: "https://img1.wsimg.com/isteam/ip/9c27c199-8240-446f-af0d-1ed5fc5c4563/tYG6e8uW9DYr0oB7LZSDnypVQ.webp",
  hzExtra4: "https://img1.wsimg.com/isteam/ip/9c27c199-8240-446f-af0d-1ed5fc5c4563/97n35bazHor8KOObsPanX0X9zdY.webp",
  hzExtra5: "https://img1.wsimg.com/isteam/ip/9c27c199-8240-446f-af0d-1ed5fc5c4563/vZDSNSKey8FmTwpadKx0IpxU.webp",
  hzExtra6: "https://img1.wsimg.com/isteam/ip/9c27c199-8240-446f-af0d-1ed5fc5c4563/fYlgTnVerOpIJEYlwoXVm1h8g.jpg",
  hzExtra7: "https://img1.wsimg.com/isteam/ip/9c27c199-8240-446f-af0d-1ed5fc5c4563/4U58QRmjMKwRTVVx8BUWWeC0c%20(1).jpg",
  hzExtra8: "https://img1.wsimg.com/isteam/ip/9c27c199-8240-446f-af0d-1ed5fc5c4563/Y1baSINSw9zaaiLX3A0f8ftqX7c.webp",
  hzExtra9: "https://img1.wsimg.com/isteam/ip/9c27c199-8240-446f-af0d-1ed5fc5c4563/2N4lkmZFMHfHGfQmfIii5Bw9G6o.webp",
  hzExtra10: "https://img1.wsimg.com/isteam/ip/9c27c199-8240-446f-af0d-1ed5fc5c4563/Y2xpxa2DHMJlV3Y3Ak1mGQraw%20(1).webp",
  hzExtra11: "https://img1.wsimg.com/isteam/ip/9c27c199-8240-446f-af0d-1ed5fc5c4563/w0lDuFpRueBVMxorvZe60Ytys.webp",
  hzExtra12: "https://img1.wsimg.com/isteam/ip/9c27c199-8240-446f-af0d-1ed5fc5c4563/QeUaYYecQlHiI627WrkiO20AW0E.jpg",
  hzExtra13: "https://img1.wsimg.com/isteam/ip/9c27c199-8240-446f-af0d-1ed5fc5c4563/WX2o0vs4sGeWpob8K6UOnVCfak.webp",
  // Additional fishing photos from kids-fishing-charter gallery
  hzFish1: "https://img1.wsimg.com/isteam/ip/9c27c199-8240-446f-af0d-1ed5fc5c4563/PHOTO-2026-02-24-16-53-36.jpg",
  hzFish2: "https://img1.wsimg.com/isteam/ip/9c27c199-8240-446f-af0d-1ed5fc5c4563/PHOTO-2026-02-24-16-53-38%208.jpg",
  hzFish3: "https://img1.wsimg.com/isteam/ip/9c27c199-8240-446f-af0d-1ed5fc5c4563/PHOTO-2026-02-24-16-53-38%209.jpg",
  hzFish4: "https://img1.wsimg.com/isteam/ip/9c27c199-8240-446f-af0d-1ed5fc5c4563/PHOTO-2026-02-24-16-53-38%2013.jpg",
  hzFish5: "https://img1.wsimg.com/isteam/ip/9c27c199-8240-446f-af0d-1ed5fc5c4563/PHOTO-2026-02-24-16-53-38%2015.jpg",
  hzFish6: "https://img1.wsimg.com/isteam/ip/9c27c199-8240-446f-af0d-1ed5fc5c4563/PHOTO-2026-02-24-16-53-38%2017.jpg",
  hzFish7: "https://img1.wsimg.com/isteam/ip/9c27c199-8240-446f-af0d-1ed5fc5c4563/PHOTO-2026-02-24-16-53-38%207.jpg",
  hzFish8: "https://img1.wsimg.com/isteam/ip/9c27c199-8240-446f-af0d-1ed5fc5c4563/PHOTO-2026-02-24-16-53-38%202.jpg",
  hzFish9: "https://img1.wsimg.com/isteam/ip/9c27c199-8240-446f-af0d-1ed5fc5c4563/PHOTO-2026-02-24-16-53-39%204.jpg",
  hzFish10: "https://img1.wsimg.com/isteam/ip/9c27c199-8240-446f-af0d-1ed5fc5c4563/PHOTO-2026-02-24-16-53-39%206.jpg",
  hzFish11: "https://img1.wsimg.com/isteam/ip/9c27c199-8240-446f-af0d-1ed5fc5c4563/PHOTO-2026-02-24-16-53-39%207.jpg",
  hzFish12: "https://img1.wsimg.com/isteam/ip/9c27c199-8240-446f-af0d-1ed5fc5c4563/PHOTO-2026-02-24-16-53-39%209.jpg",
  // About Us — original crew photos
  hzScott: "https://img1.wsimg.com/isteam/ip/9c27c199-8240-446f-af0d-1ed5fc5c4563/Facetune_12-03-2026-13-33-54.jpeg",
  hzInstructors: "https://img1.wsimg.com/isteam/ip/9c27c199-8240-446f-af0d-1ed5fc5c4563/IMG_5698.jpeg",
  hzHunter: "https://img1.wsimg.com/isteam/ip/9c27c199-8240-446f-af0d-1ed5fc5c4563/Facetune_12-03-2026-13-31-32-7a95662.jpeg",
  hzZion: "https://img1.wsimg.com/isteam/ip/9c27c199-8240-446f-af0d-1ed5fc5c4563/IMG_5838.JPG",
  hzGarrett: "https://img1.wsimg.com/isteam/ip/9c27c199-8240-446f-af0d-1ed5fc5c4563/Facetune_12-03-2026-13-33-23.jpeg",
  hzNate: "https://img1.wsimg.com/isteam/ip/9c27c199-8240-446f-af0d-1ed5fc5c4563/IMG_5877.jpeg",
  hzMegan: "https://img1.wsimg.com/isteam/ip/9c27c199-8240-446f-af0d-1ed5fc5c4563/Facetune_12-03-2026-13-32-10.jpeg",
  surf1: "https://images.unsplash.com/photo-1613457869704-9bb9fb946015?crop=entropy&cs=srgb&fm=jpg&q=85",
  surf2: "https://images.pexels.com/photos/27505450/pexels-photo-27505450.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
  surf3: "https://images.pexels.com/photos/4321928/pexels-photo-4321928.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
  surf4: "https://images.unsplash.com/photo-1631138751417-630fc3d497e1?crop=entropy&cs=srgb&fm=jpg&q=85",
  surf5: "https://images.unsplash.com/photo-1613486185528-d9b0ae83f008?crop=entropy&cs=srgb&fm=jpg&q=85",
  surf6: "https://images.unsplash.com/photo-1664088673619-38b275539bf9?crop=entropy&cs=srgb&fm=jpg&q=85",
  fish1: "https://images.unsplash.com/photo-1551131618-3f0a5cf594b4?crop=entropy&cs=srgb&fm=jpg&q=85",
  fish2: "https://images.unsplash.com/photo-1625183656263-171183307b15?crop=entropy&cs=srgb&fm=jpg&q=85",
  fish3: "https://images.unsplash.com/photo-1664420739230-6b46664269fa?crop=entropy&cs=srgb&fm=jpg&q=85",
  fish4: "https://images.unsplash.com/photo-1638340384339-1faaf6d17655?crop=entropy&cs=srgb&fm=jpg&q=85",
  jet1: "https://images.unsplash.com/photo-1761418741711-aeefe283a9aa?crop=entropy&cs=srgb&fm=jpg&q=85",
  jet2: "https://images.unsplash.com/photo-1764132868176-e1abc06ae538?crop=entropy&cs=srgb&fm=jpg&q=85",
  jet3: "https://images.unsplash.com/photo-1721798974342-7b2b859493a0?crop=entropy&cs=srgb&fm=jpg&q=85",
  jet4: "https://images.unsplash.com/photo-1773146902998-ed7143d0bf8e?crop=entropy&cs=srgb&fm=jpg&q=85",
  sunset1: "https://images.unsplash.com/photo-1501436513145-30f24e19fcc8?crop=entropy&cs=srgb&fm=jpg&q=85",
  sunset2: "https://images.unsplash.com/photo-1533371452382-d45a9da51ad9?crop=entropy&cs=srgb&fm=jpg&q=85",
  sunset3: "https://images.unsplash.com/photo-1503803548695-c2a7b4a5b875?crop=entropy&cs=srgb&fm=jpg&q=85",
  sunset4: "https://images.unsplash.com/photo-1581116972164-b89ed0cdf64f?crop=entropy&cs=srgb&fm=jpg&q=85",
  whale1: "https://images.unsplash.com/photo-1568430462989-44163eb1752f?crop=entropy&cs=srgb&fm=jpg&q=85",
  whale2: "https://images.unsplash.com/photo-1475318681864-ef1966c3cbb7?crop=entropy&cs=srgb&fm=jpg&q=85",
  sail1: "https://images.unsplash.com/photo-1608912282154-658b33113906?crop=entropy&cs=srgb&fm=jpg&q=85",
  paddle1: "https://images.unsplash.com/photo-1620760039098-6b3a7a95fe4a?crop=entropy&cs=srgb&fm=jpg&q=85",
  paddle2: "https://images.unsplash.com/photo-1644153502257-69f24ac5ab8b?crop=entropy&cs=srgb&fm=jpg&q=85",
  paddle3: "https://images.unsplash.com/photo-1571690102472-1851d1dc4474?crop=entropy&cs=srgb&fm=jpg&q=85",
  kids1: "https://images.unsplash.com/photo-1730761970652-2e45c1ab3fdf?crop=entropy&cs=srgb&fm=jpg&q=85",
  kids2: "https://images.unsplash.com/photo-1458592918806-99f9cfbe41fc?crop=entropy&cs=srgb&fm=jpg&q=85",
  tropical1: "https://images.unsplash.com/photo-1761576881154-42de9dc70b25?crop=entropy&cs=srgb&fm=jpg&q=85",
  tropical2: "https://images.unsplash.com/photo-1660020140973-4a18a4b46d14?crop=entropy&cs=srgb&fm=jpg&q=85",
};

export const CONTACT = {
  name: "Hang Zen Surf + Sea",
  address: "916 Neptune Ave, Encinitas, CA, USA",
  phone: "(760) 331-3243",
  phoneRaw: "7603313243",
  email: "hangzensurfschool@gmail.com",
  facebook: "https://www.facebook.com/hangzensurf",
  instagram: "https://www.instagram.com/hangzensurfsea",
  paypal: "https://www.paypal.com/paypalme/ScottHamrick333",
  hours: [
    { day: "Mon", time: "5:30 AM – 8:00 PM" },
    { day: "Tue", time: "5:30 AM – 8:00 PM" },
    { day: "Wed", time: "5:30 AM – 8:00 PM" },
    { day: "Thu", time: "5:30 AM – 8:00 PM" },
    { day: "Fri", time: "5:30 AM – 8:00 PM" },
    { day: "Sat", time: "5:30 AM – 8:00 PM" },
    { day: "Sun", time: "9:00 AM – 5:00 PM" },
  ],
};

export const NAV = [
  { label: "Home", path: "/" },
  {
    label: "Surf",
    children: [
      { label: "Private Lessons", path: "/private-lessons" },
      { label: "Semi Private", path: "/semi-private" },
      { label: "Group Lessons", path: "/group-lessons" },
      { label: "Kids Surf Camps", path: "/kids-surf-camps" },
      { label: "Hotel Lessons", path: "/hotel-lessons" },
    ],
  },
  {
    label: "Fish",
    children: [
      { label: "Kids Fishing Charter", path: "/kids-fishing-charter" },
      { label: "San Diego Bay Fishing", path: "/san-diego-bay-fishing" },
      { label: "Offshore - Outerbanks", path: "/offshore-outerbanks" },
      { label: "Coronado Islands", path: "/coronado-islands" },
    ],
  },
  {
    label: "Activities",
    children: [
      { label: "Whale & Dolphin Watching", path: "/whale-dolphin-watching" },
      { label: "Sunset Cruises", path: "/sunset-cruises" },
      { label: "Paddle Boarding", path: "/paddle-boarding" },
      { label: "Catalina Island Tours", path: "/catalina-island-tours" },
    ],
  },
  {
    label: "Retreats",
    children: [{ label: "Nicaragua", path: "/nicaragua" }],
  },
  {
    label: "Locations",
    children: [
      { label: "Encinitas — Surf Lessons", path: "/surf-lessons/encinitas" },
      { label: "San Diego — Surf Lessons", path: "/surf-lessons/san-diego" },
      { label: "So Cal — Surf Lessons", path: "/surf-lessons/so-cal" },
      { label: "Encinitas — Fishing", path: "/fishing-trips/encinitas" },
      { label: "San Diego — Fishing", path: "/fishing-trips/san-diego" },
      { label: "So Cal — Fishing", path: "/fishing-trips/so-cal" },
    ],
  },
  { label: "Gallery", path: "/gallery" },
  { label: "About Us", path: "/about-us" },
  { label: "Book Today", path: "/book-today" },
];

export const SURF_SERVICES = [
  {
    title: "Private Lessons",
    price: "$165",
    unit: "PER HOUR AND HALF - PER PERSON",
    desc: "Personalized one-on-one coaching tailored to your skill level. Move quickly from pop-ups to riding green waves with confidence.",
    image: "hzPriv1",
    path: "/private-lessons",
  },
  {
    title: "Hotel Lessons",
    price: "$165",
    unit: "One on One - PER HOUR - PER PERSON",
    desc: "We deliver the surf school straight to your hotel — boards, wetsuits, and pro instructors. The easiest way to surf San Diego.",
    image: "hzHotel2",
    path: "/hotel-lessons",
  },
  {
    title: "Semi Private Lessons",
    price: "$130",
    unit: "(2) Person Semi-Private - 1.5 Hours",
    desc: "Bring a friend or partner and learn together. Two students per instructor for focused, fun coaching in the lineup.",
    image: "hzSemi1",
    path: "/semi-private",
  },
  {
    title: "Group Lessons",
    price: "$95",
    unit: "(3+) Person Group - One Hour",
    desc: "Perfect for families, friends, and team-building. High-energy group sessions with multiple instructors in the water.",
    image: "hzGroup1",
    path: "/group-lessons",
  },
  {
    title: "Kids Surf Camps",
    price: "From $295",
    unit: "Multi-day Summer Camps",
    desc: "Multi-day surf camps for groms ages 6–14. Ocean safety, paddling, popping up, and a whole lot of stoke.",
    image: "hzKids1",
    path: "/kids-surf-camps",
  },
  {
    title: "Jet Ski Assist – Step Off",
    price: "Inquire",
    unit: "Tow-in for advanced surfers",
    desc: "Jet ski tow-in and step-off sessions for intermediate and advanced surfers chasing bigger waves and faster entry.",
    image: "hzJet1",
    path: "/private-lessons",
  },
];

export const FISH_SERVICES = [
  {
    title: "Kid's Fishing Charter",
    price: "$750",
    unit: "4 Hours · Up to 4 guests ($100 each additional)",
    desc: "A fun and high-action trip designed for younger anglers. Learn the basics of rod handling, baiting, casting, and fish identification.",
    image: "hzKidsFish1",
    path: "/kids-fishing-charter",
  },
  {
    title: "San Diego Bay Fishing",
    price: "$749 / $949",
    unit: "4 Hours / 6 Hours · Up to 3 guests",
    desc: "A focused inshore fishing trip inside San Diego Bay with steady action and calm, protected waters.",
    image: "hzBay1",
    path: "/san-diego-bay-fishing",
  },
  {
    title: "Offshore – Outerbanks",
    price: "$2,500",
    unit: "9 Hours · Up to 3 guests",
    desc: "Run offshore in pursuit of Southern California's hardest-fighting pelagic fish like tuna, yellowtail, and mahi.",
    image: "hzOffshore1",
    path: "/offshore-outerbanks",
  },
  {
    title: "Coronado Islands",
    price: "$1,200 +",
    unit: "6 / 8 / 10 Hours · Up to 3 guests",
    desc: "A high-action fishing adventure in Mexican waters targeting a wide range of species: yellowtail, calico, rockfish & more.",
    image: "hzCoronado1",
    path: "/coronado-islands",
  },
];

export const SEA_SERVICES = [
  {
    title: "Jet Ski Adventures",
    price: "$220 / $410",
    unit: "1 Hour / 2 Hours (most popular)",
    desc: "Guided jet ski adventures along the San Diego coastline. Scenic cruises through the bay or open-sea rides past Oceanside Pier.",
    image: "hzJet3",
    path: "/jet-ski-adventures",
  },
  {
    title: "Dolphin & Whale Watching",
    price: "$550",
    unit: "3 Hours · Up to 5 people",
    desc: "Experience Southern California's coastline from the water as we search for dolphins, migrating whales, and marine life.",
    image: "hzWhale1",
    path: "/whale-dolphin-watching",
  },
  {
    title: "Sunset Cruises",
    price: "$550",
    unit: "3 Hours · Up to 5 people",
    desc: "A relaxed evening cruise along the coast as the sun sets over the Pacific. Panoramic views and glowing skies.",
    image: "hzSunset1",
    path: "/sunset-cruises",
  },
  {
    title: "Catalina Island Tours",
    price: "Inquire",
    unit: "Private offshore charter",
    desc: "A private charter to Catalina Island. Spend the day swimming, exploring coves, and the harbor town of Avalon.",
    image: "hzCatalina1",
    path: "/catalina-island-tours",
  },
  {
    title: "Paddle Boarding",
    price: "Rentals & Tours",
    unit: "Carlsbad Lagoon & North County",
    desc: "Explore Carlsbad Lagoon and North County beaches with paddle board rentals or guided sessions for all skill levels.",
    image: "hzPaddle1",
    path: "/paddle-boarding",
  },
];

export const SERVICE_DETAILS = {
  "private-lessons": {
    title: "Private Surf Lessons",
    tagline: "One on One Coaching · Encinitas, CA",
    hero: "hzPriv1",
    price: "$165",
    priceNote: "per hour and half · per person",
    duration: "1.5 Hours",
    includes: ["Soft-top surfboard", "Wetsuit", "Rashguard", "Certified instructor", "Ocean safety briefing"],
    description:
      "Our private surf lessons are the fastest way to learn. With one instructor entirely focused on you, we tailor every wave, every tip, and every drill to your skill level. Whether you've never touched a board or you're working on cutbacks, your instructor will be in the water with you the whole session.",
    gallery: ["hzPriv2", "hzExtra8"],
  },
  "hotel-lessons": {
    title: "Hotel Surf Lessons",
    tagline: "We bring the surf school to you",
    hero: "hzHotel2",
    price: "$165",
    priceNote: "per hour · per person",
    duration: "1 Hour",
    includes: ["Hotel pickup option", "All gear delivered", "Pro instructor", "Photos included"],
    description:
      "Staying at a beachfront hotel? We deliver boards, wetsuits, and an instructor right to your sand. No driving, no hassle — just step out of your hotel and start surfing.",
    gallery: ["hzExtra9", "hzExtra10"],
  },
  "semi-private": {
    title: "Semi-Private Lessons",
    tagline: "Learn with a partner · 2 students per instructor",
    hero: "hzSemi1",
    price: "$130",
    priceNote: "per person · 1.5 hours",
    duration: "1.5 Hours",
    includes: ["2 students per instructor", "Boards & wetsuits", "In-water coaching", "Video tips"],
    description:
      "Grab a friend, partner, or sibling. Semi-private lessons give you focused coaching while sharing the stoke with someone you love.",
    gallery: ["hzSemi2", "hzExtra12"],
  },
  "group-lessons": {
    title: "Group Surf Lessons",
    tagline: "Up to 6 students · Great for families & teams",
    hero: "hzGroup1",
    price: "$95",
    priceNote: "per person · 1 hour",
    duration: "1 Hour",
    includes: ["Multiple instructors", "All equipment", "Group photos", "High-energy session"],
    description:
      "Perfect for families, corporate retreats, bachelorette parties, and friend groups. We staff up so everyone gets attention.",
    gallery: ["hzGroup2", "hzExtra1"],
  },
  "kids-surf-camps": {
    title: "Kids Surf Camps",
    tagline: "Grom Camps · Ages 6–14",
    hero: "hzKids1",
    price: "From $295",
    priceNote: "3-day & 5-day camps",
    duration: "Multi-day",
    includes: ["3-hour daily sessions", "All gear", "Beach games", "Ocean safety education", "End-of-week awards"],
    description:
      "Our summer surf camps are the highlight of the season. Kids learn ocean awareness, paddling, popping up, and reading waves — all while making lifelong friends.",
    gallery: ["hzKids2", "hzExtra2"],
  },
  "kids-fishing-charter": {
    title: "Kid's Fishing Charter",
    tagline: "Designed for young anglers",
    hero: "hzKidsFish1",
    price: "$750",
    priceNote: "4 Hours · Up to 4 guests · +$100 each additional",
    duration: "4 Hours",
    includes: ["All tackle & bait", "Kid-friendly captain", "Fish identification", "Snacks & water"],
    description:
      "A fun and high-action trip designed for younger anglers. Learn the basics of rod handling, baiting, casting, and fish identification while enjoying time on the water.",
    gallery: ["hzKidsFish2", "hzFish1", "hzFish10"],
  },
  "san-diego-bay-fishing": {
    title: "San Diego Bay Fishing",
    tagline: "Calm, protected waters · Steady action",
    hero: "hzBay1",
    price: "$749 / $949",
    priceNote: "4 Hours / 6 Hours · Up to 3 guests",
    duration: "4–6 Hours",
    includes: ["Bait & tackle", "Licensed captain", "Filleting service", "Cooler"],
    description:
      "A focused inshore fishing trip inside San Diego Bay with steady action and calm, protected waters. Target spotted bay bass, halibut, sand bass and more.",
    gallery: ["hzBay2", "hzFish9", "hzFish2"],
  },
  "offshore-outerbanks": {
    title: "Offshore – Outerbanks",
    tagline: "Bluewater · Pelagic species",
    hero: "hzOffshore1",
    price: "$2,500",
    priceNote: "9 Hours · Up to 3 guests",
    duration: "9 Hours",
    includes: ["Full offshore tackle", "Bait", "Fuel", "Filleting", "Cooler & ice"],
    description:
      "Run offshore in pursuit of Southern California's hardest-fighting pelagic fish like tuna, yellowtail, dorado (mahi), and bonito. Big water, big fish, big day.",
    gallery: ["hzFish11", "hzFish12", "hzHome1"],
  },
  "coronado-islands": {
    title: "Coronado Islands",
    tagline: "Mexican waters · Multi-species",
    hero: "hzCoronado1",
    price: "$1,200 / $1,600 / $2,100",
    priceNote: "6 / 8 / 10 Hours · Up to 3 guests",
    duration: "6–10 Hours",
    includes: ["Mexican fishing licenses", "Tackle & bait", "Filleting", "Cooler"],
    description:
      "A high-action fishing adventure in Mexican waters targeting a wide range of species including yellowtail, calico bass, rockfish, lingcod, and bonito.",
    gallery: ["hzCoronado2", "hzFish8", "hzFish3"],
  },
  "whale-dolphin-watching": {
    title: "Whale & Dolphin Watching",
    tagline: "3 Hour Marine Wildlife Charter",
    hero: "hzWhale1",
    price: "$550",
    priceNote: "3 Hours · Up to 5 people",
    duration: "3 Hours",
    includes: ["Marine naturalist", "Drinks & snacks", "Photo ops", "Binoculars onboard"],
    description:
      "Experience Southern California's coastline from the water as we search for dolphins, migrating gray whales, blue whales (seasonal), and other marine life.",
    gallery: ["hzExtra4", "hzExtra5"],
  },
  "sunset-cruises": {
    title: "Sunset Cruises",
    tagline: "Glow on the Pacific",
    hero: "hzSunset1",
    price: "$550",
    priceNote: "3 Hours · Up to 5 people",
    duration: "3 Hours",
    includes: ["Captain & first mate", "Bring your own drinks", "Music system", "Blankets"],
    description:
      "A relaxed evening cruise along the coast as the sun sets over the Pacific. Panoramic views, glowing skies, and the calm that only comes at the end of the day.",
    gallery: ["hzExtra6", "hzExtra11"],
  },
  "paddle-boarding": {
    title: "Paddle Boarding",
    tagline: "Carlsbad Lagoon & North County Beaches",
    hero: "hzPaddle1",
    price: "From $45",
    priceNote: "per hour · rentals & guided",
    duration: "Flexible",
    includes: ["SUP board", "Paddle", "PFD", "Optional guide"],
    description:
      "Explore Carlsbad Lagoon and North County beaches with paddle board rentals or guided sessions for all skill levels. Family-friendly and beginner-welcoming.",
    gallery: ["hzExtra7", "hzExtra3"],
  },
  "catalina-island-tours": {
    title: "Catalina Island Tours",
    tagline: "Private offshore charter",
    hero: "hzCatalina1",
    price: "Inquire",
    priceNote: "Custom day charters",
    duration: "Full Day",
    includes: ["Captain", "Fuel", "Snorkel gear", "Lunch option"],
    description:
      "A private offshore charter to Catalina Island. Spend the day swimming, exploring coves, snorkeling, and visiting the harbor town of Avalon.",
    gallery: ["hzHome2", "hzHome3"],
  },
  nicaragua: {
    title: "Nicaragua Surf Retreat",
    tagline: "7 Days · All-inclusive · Endless waves",
    hero: "hzNicaragua1",
    price: "From $2,495",
    priceNote: "per person · double occupancy",
    duration: "7 Days / 6 Nights",
    includes: [
      "Beachfront lodging",
      "3 daily meals",
      "Daily surf coaching",
      "Boards & wetsuits",
      "Boat trips to secret spots",
      "Yoga sessions",
      "Airport transfers",
    ],
    description:
      "Escape with us to Nicaragua's legendary Pacific coast. Offshore winds nearly every day, warm water, and uncrowded points. We handle every detail so you can focus on surfing and resetting.",
    gallery: ["hzExtra13", "hzFish7"],
  },
};

export const TESTIMONIALS = [
  {
    name: "Victoria Bruns",
    handle: "10 reviews · 2 photos",
    initial: "V",
    color: "from-yellow-400 to-amber-500",
    when: "3 weeks ago",
    rating: 5,
    text: "Scotty came highly recommended by my cousins who are Encinitas locals — their son took lessons from him and knew he'd be the perfect fit for my 6-year-old son and me. And they were absolutely right! We had an absolute blast. It was our very first time surfing, and Scotty was incredibly thorough and attentive to my son, which I deeply appreciated as a parent. He kept the focus on safety while ensuring we learned a ton and shredded plenty of waves. We will definitely be back for more lessons with Scotty on our next trip up from Florida!",
  },
  {
    name: "Jenn Goldberg",
    handle: "jules grey jewels",
    initial: "J",
    color: "from-rose-400 to-pink-500",
    when: "17 hours ago",
    rating: 5,
    text: "I can't say enough great things about Scott and Team, and honestly couldn't think of one negative aspect if I tried in regards to how awesome our first experience was with them! My 11 year old son had the best time surfing all week with his buddies, and we're already coordinating our next private lessons to keep them all growing this summer in skill, confidence, and comfort. Scott and Team were extremely kind, flexible, and made all of our boys eager to keep improving!",
  },
  {
    name: "Megan Martinez",
    handle: "2 reviews · 1 photo",
    initial: "M",
    color: "from-violet-500 to-purple-600",
    when: "a week ago",
    rating: 5,
    text: "Scott and his staff were excellent. We loved the instruction, attention to safety, and the fun! We did lessons with 1 adult and 3 kids aged 7–13 and the instruction and adapted style for each of us made for a wonderful experience!",
  },
  {
    name: "Andy Payne",
    handle: "6 reviews",
    initial: "A",
    color: "from-cyan-500 to-sky-600",
    when: "a week ago",
    rating: 5,
    text: "Best surf school near Encinitas!!! I've taken many surf lessons around the world but nothing compares to the instruction I received from Hang Zen! If you want to actually become a surfer and learn to catch waves on your own, this is the school you need to check out! ALSO — Taking a break from catching waves? Perfect time to catch some fish! I was psyched to learn that Hang Zen offers Deep Sea fishing trips out of Oceanside.",
  },
  {
    name: "Anjuli Arora Dow",
    handle: "1 review · 1 photo",
    initial: "A",
    color: "from-emerald-500 to-teal-600",
    when: "2 days ago",
    rating: 5,
    text: "Scott and his team are incredible! They took my 11 year old son and his 3 friends out all week and they always came back smiling with confidence building through the week! They are so encouraging and kind and I highly recommend Scott!!!",
  },
  {
    name: "Ava Mills",
    handle: "3 reviews",
    initial: "A",
    color: "from-slate-500 to-slate-700",
    when: "2 weeks ago",
    rating: 5,
    text: "Had the best time! Caught so many waves. 10 out of 10 experience!! Absolute best instructor. Would definitely recommend.",
  },
  {
    name: "Andrea Hayles",
    handle: "1 review",
    initial: "A",
    color: "from-indigo-500 to-blue-600",
    when: "3 weeks ago",
    rating: 5,
    text: "Our experience of a fun and successful surf lesson in Encinitas with Hang Zen Surf was excellent! We've used them many times and would highly recommend this surf school.",
  },
  {
    name: "Claire Adams",
    handle: "2 reviews",
    initial: "C",
    color: "from-rose-500 to-fuchsia-600",
    when: "a week ago",
    rating: 5,
    text: "My son has taken several surf lessons with Scott and absolutely loves them. He's learned so much, improved a ton, and has become really confident and comfortable in the water. Scott is patient, encouraging, and great with kids. Highly recommend!",
  },
  {
    name: "Ryley Byers",
    handle: "1 review",
    initial: "R",
    color: "from-purple-500 to-violet-700",
    when: "2 weeks ago",
    rating: 5,
    text: "Had a great time. Amazing instructor! So kind and helpful. Will definitely be doing that again next time I visit.",
  },
  {
    name: "Jay B",
    handle: "3 reviews · 1 photo",
    initial: "J",
    color: "from-amber-500 to-orange-600",
    when: "22 hours ago",
    rating: 5,
    text: "Good people and business. They are willing to work with you, even if you don't make much progress. You will have no issue with getting up to speed with their instructors. They tell you everything on how to surf and what to improve on.",
  },
];

export const GOOGLE_REVIEWS_URL =
  "https://www.google.com/maps/search/?api=1&query=Hang+Zen+Surf+Sea+916+Neptune+Ave+Encinitas+CA";

export const GOOGLE_WRITE_REVIEW_URL =
  "https://search.google.com/local/writereview?placeid=ChIJ_Hang_Zen_Surf_Sea_Encinitas";
